import { QuoteDetails } from 'components/common-form/sidePanel/info/Details/QuoteDetails';
import { FC } from 'react';

import { ProductDump } from '../ProductDump';
import { InfoTabPanel } from './InfoTabPanel';
import type { InfoProps } from './QuoteInfos.connect';

export const RawQuoteInfos: FC<InfoProps> = ({
  tabId,
  workspaceType,
  hasDetails,
  hasProductDump,
  isInternalUser,
  externalQuoteId,
  quoteId,
  quoteDetails,
  fieldsShouldBeReferenced,
  quoteDetailsMetadata,
}) => {
  if (!hasDetails) {
    return null;
  }
  if (!isInternalUser) {
    return (
      <div className="overflow-y-auto h-100">
        <QuoteDetails
          tabId={tabId}
          fieldsShouldBeReferenced={fieldsShouldBeReferenced}
          externalQuoteId={externalQuoteId}
          quoteId={quoteId}
          workspaceType={workspaceType}
          data={quoteDetails}
          quoteDetailsMetadata={quoteDetailsMetadata}
        />
      </div>
    );
  }
  return (
    <InfoTabPanel
      tabId={tabId}
      hasProductDump={hasProductDump}
      detailsContent={
        <QuoteDetails
          tabId={tabId}
          fieldsShouldBeReferenced={fieldsShouldBeReferenced}
          externalQuoteId={externalQuoteId}
          quoteId={quoteId}
          workspaceType={workspaceType}
          data={quoteDetails}
          quoteDetailsMetadata={quoteDetailsMetadata}
        />
      }
      productDumpContent={<ProductDump pricingId={quoteDetails?.PricerRfqId} />}
    />
  );
};
